import AutoCompleteSetor from "./AutoCompleteSetor";
import Carregando from "./Carregando";
import CarregarSetor from "./CarregarSetor";
import {Botao, BotaoAdicionar, BotaoAlterar, BotaoEnviar, BotaoImprimir, BotaoFechar, BotaoSalvar, BotaoExcluir, BotaoPesquisar} from "./botao/Botao";
import ExibeSetor from "./ExibeSetor";
import {Icone} from "./Icone";
import {ExibirModal, PaginaLogada} from "./layout";
import {Ribbon} from "./Ribbon";
import {SelectFetch} from './form/SelectFetch';

export function getClasse(classe) {
    return !classe ? "" : classe.toString()+" ";
}

export {
    AutoCompleteSetor,
    Botao, BotaoAdicionar, BotaoAlterar, BotaoEnviar, BotaoImprimir, BotaoFechar, BotaoSalvar, BotaoExcluir, BotaoPesquisar,
    Carregando,
    CarregarSetor,
    ExibirModal,
    ExibeSetor,
    Icone,
    SelectFetch,
    PaginaLogada,
    Ribbon
}
